import { useCallback, useRef } from 'react';
import {
  validateImageAsync as validateImageAsyncInternal,
  validateVideoAsync,
  readFileAsDataURLAsync,
} from '@bingads-webui-campaign-react/upload-file-picker';
import { getImageDetailAsync } from '@bingads-webui-campaign/image-experience-utils';
import { MIN_SIZE, UPSCALE_MIN_SIZE } from '../model';

const READ_VIDEO_MAX_TIME = 10000; // 10s

export const useReadAsset = () => {
  const readFileAsync = useCallback((fileObject, { isVideo } = {}) => {
    if (isVideo) {
      // for video, data URl is optional to MT request, so here swallow the error to unblock next.
      return readFileAsDataURLAsync(fileObject).timeout(READ_VIDEO_MAX_TIME).catch(() => {});
    }

    return readFileAsDataURLAsync(fileObject);
  }, []);

  return {
    readFileAsync,
  };
};

export const useValidateAsset = () => {
  const isImageUpscaledRef = useRef(false);

  const validateImageAsync = useCallback(
    ({ dataURL, isUploadImageUpscaleEnabled }) => validateImageAsyncInternal({
      imageSource: dataURL,
      minimumHeight: isUploadImageUpscaleEnabled ? UPSCALE_MIN_SIZE[1] : MIN_SIZE[1],
      minimumWidth: isUploadImageUpscaleEnabled ? UPSCALE_MIN_SIZE[0] : MIN_SIZE[0],
    })
      .then(() => getImageDetailAsync(dataURL))
      .then((img) => {
        if (isUploadImageUpscaleEnabled && img &&
          ((img.naturalWidth >= UPSCALE_MIN_SIZE[0] && img.naturalWidth < MIN_SIZE[0]) ||
            (img.naturalHeight >= UPSCALE_MIN_SIZE[1] && img.naturalHeight < MIN_SIZE[1]))
        ) {
          isImageUpscaledRef.current = true;
        } else {
          isImageUpscaledRef.current = false;
        }
        return {
          isImageUpscaled: isImageUpscaledRef.current,
        };
      })
    , []
  );

  const validateFileAsync = useCallback(({ dataURL, isVideo, isUploadImageUpscaleEnabled }) => {
    if (isVideo) {
      return validateVideoAsync();
    }

    return validateImageAsync({ dataURL, isUploadImageUpscaleEnabled });
  }, [validateImageAsync]);

  return {
    validateImageAsync,
    validateFileAsync,
  };
};
